// Import all email component types
import Header from './Header';
import Banner from './Banner';
import LeftAlignImage from './LeftAlignImage';
import RightAlignImage from './RightAlignImage';
import ThreeIconContent from './ThreeIconContent';
import ThreeColThreeImg from './3Col_3Img';
import TitleDescription from './TitleDescription';
import ProductGrid from './ProductGrid';
import ImageTextFeature from './ImageTextFeature';
import HeaderImageText from './HeaderImageText';
import HeadingDescription from './HeadingDescription';
import CenteredHeading from './CenteredHeading';
import OfferBlock from './OfferBlock';
import MultiColumnLayout from './MultiColumnLayout';
import Button from './Button';
import Footer from './Footer';
import BaseEmailComponent from './BaseEmailComponent';
import LeftImageRightContent from './LeftImageRightContent';
import RightImageLeftContent from './RightImageLeftContent';
import Title_4Img from './Title_4Img';
import ImgCircle from './Img_circle';
import DescriptionBtn from './Description_btn';
import TwoColThreeRowsBenefits from './2COL_3ROWS_Benefits';
import OfferDetailsH1Desc from './OfferDetails_H1_Desc';
import FAQGeneric from './faq_generic';
import EcomIngredients from './ecom_ingredients';
import TwoCol from './2Col';
import ThreeColOneImgCenter from './3Col_1Img_center';
import FourColFourImgTitlePrice from './4Col_4Img_Title_price';
import FourColOneImgLeft from './4Col_1Img_left';
import H1AlignRightDesc from './H1_AlignRight_Desc';
import HeaderTitleDesc from './Header_Title_Desc';
import H1Desc4 from './H1_Desc_4';
import H1Desc5 from './H1_Desc_5';
import H1Desc6 from './H1_Desc_6';
import H1H2Desc4 from './H1_H2_Desc_4';
import OfferDetailsDesc3 from './OfferDetails_Desc_3';

/**
 * Registry of all available email components.
 * Maps component names to their React component implementations.
 */
const COMPONENT_REGISTRY = {
  // Basic Components
  'Header': Header,
  'Banner': Banner,
  'Img_circle': ImgCircle,
  'Img_Circle': ImgCircle,
  'Button': Button,
  'Footer': Footer,
  'Header_Title_Desc': HeaderTitleDesc,
  'Header_Title_Description': HeaderTitleDesc,
  
  // Layout Components
  '2Col': TwoCol,
  '2Col_1Img_left': LeftAlignImage,
  '2Col_1Img_right': RightAlignImage,
  'Left_Image_Right_Title_Desc_Btn': LeftImageRightContent,
  'Right_Image_Left_Title_Desc_Btn': RightImageLeftContent,
  'LeftAlignImage': LeftAlignImage,
  'RightAlignImage': RightAlignImage,
  'LeftImageRightContent': LeftImageRightContent,
  'RightImageLeftContent': RightImageLeftContent,
  '3Col_3Img': ThreeColThreeImg,
  '3Col_3Img_old': ThreeIconContent, // Keep old one for backward compatibility
  '3Col_1Img_center': ThreeColOneImgCenter,
  '3Col_1Img_Center': ThreeColOneImgCenter,
  'Title_4Img': Title_4Img,
  'H1_4Img': Title_4Img,
  'Title_4Img_Grid': Title_4Img,
  '4Col': Title_4Img,
  '4Col_4Img': Title_4Img,
  '4Col_4Img_Title_price': FourColFourImgTitlePrice,
  '4Col_4Img_Title_Price': FourColFourImgTitlePrice,
  '4Col_1Img_left': FourColOneImgLeft,
  '4Col_1Img_Left': FourColOneImgLeft,
  'FourCol_1Imgleft': FourColOneImgLeft,
  'FourCol_1ImgLeft': FourColOneImgLeft,
  
  // Text Components
  'H1_H2_Desc': TitleDescription,
  'Title_Description': TitleDescription,
  'H1_Desc': HeadingDescription,
  'Heading_Description': HeadingDescription,
  'H1_Center': CenteredHeading,
  'Centered_Heading': CenteredHeading,
  'H1_AlignRight_Desc': H1AlignRightDesc,
  'H1_Align_Right_Desc': H1AlignRightDesc,
  'H1_Desc_4': H1Desc4,
  'H1_Desc4': H1Desc4,
  'H1_Desc_5': H1Desc5,
  'H1_Desc5': H1Desc5,
  'H1_Desc_6': H1Desc6,
  'H1_Desc6': H1Desc6,
  'H1_H2_Desc_4': H1H2Desc4,
  'H1_H2_Desc4': H1H2Desc4,
  'Description_btn': DescriptionBtn,
  'Description_Btn': DescriptionBtn,
  'Centre_btn': DescriptionBtn,
  'Center_btn': DescriptionBtn,
  '2COL_3ROWS_Benefits': TwoColThreeRowsBenefits,
  '2Col_3Rows_Benefits': TwoColThreeRowsBenefits,
  
  // Product Components
  'productGrid': ProductGrid,
  'Product_Grid': ProductGrid,
  'Header_2Col_1Img_Left': HeaderImageText,
  'Header_Image_Text': HeaderImageText,
  'Image_Text_Feature': ImageTextFeature,
  
  // Special Components
  'OfferDetails_H1_Code': OfferBlock,
  'OfferDetails_H1_Desc': OfferDetailsH1Desc,
  'OfferDetails_Desc_3': OfferDetailsDesc3,
  'OfferDetails_Desc3': OfferDetailsDesc3,
  'Offer_Block': OfferBlock,
  'MultiColumnLayout': MultiColumnLayout,
  
  // FAQ Components
  'faq_generic': FAQGeneric,
  'FAQ_Generic': FAQGeneric,
  
  // E-commerce Components
  'ecom_ingredients': EcomIngredients,
  'Ecom_Ingredients': EcomIngredients,
  
  // Default/Base Component
  'Base': BaseEmailComponent
};

/**
 * Returns the React component for a given component type.
 * 
 * @param {string} type - The type of component to retrieve
 * @returns {React.Component|null} The component or null if not found
 */
export const getComponentForType = (type) => {
  if (!type) return null;
  
  // Direct lookup
  if (COMPONENT_REGISTRY[type]) {
    return COMPONENT_REGISTRY[type];
  }
  
  // Case-insensitive lookup
  const lowerType = type.toLowerCase();
  for (const [key, component] of Object.entries(COMPONENT_REGISTRY)) {
    if (key.toLowerCase() === lowerType) {
      console.log(`Using component ${key} for type ${type}`);
      return component;
    }
  }
  
  // If all else fails, return the base component
  console.warn(`No component found for type: ${type}, using BaseEmailComponent as fallback`);
  return BaseEmailComponent;
};

/**
 * Returns a list of all registered component types
 * 
 * @returns {string[]} Array of component type names
 */
export const getAllComponentTypes = () => {
  return Object.keys(COMPONENT_REGISTRY);
};

/**
 * Get a specific component by name with type safety
 * 
 * @template T
 * @param {string} type - The component type name
 * @param {T} defaultComponent - Default component to return if not found
 * @returns {React.Component|T} The component or the default
 */
export const getComponent = (type, defaultComponent = null) => {
  return getComponentForType(type) || defaultComponent;
};

export default COMPONENT_REGISTRY; 